<template>
  <NavigationHeader title="Nos événements" />
</template>

<script>
export default {
  name: 'EventsIndexHeader'
}
</script>
